document.addEventListener('DOMContentLoaded', function () {
  const custom = setInterval(() => {
    const ele = document.querySelector('#rebuy-cart__progress-bar-meter-label');
    const element = document.querySelector('.rebuy-cart__flyout-subtotal-amount span:nth-of-type(2)');
    const priceEle = document.querySelector('.rebuy-cart__flyout-subtotal-amount');
    const element_two = document.querySelectorAll('.rebuy-money span');
    const sr = document.querySelectorAll('.sr-only');
    sr.style.display = 'none';

    if(!ele) return;
    if(!element) return;
    let content = ele.textContent;
    let contents = element.textContent;

    if (content.includes(".00")) {
      let newContent = content.replace(".00", "");
      content = newContent
      ele.textContent = content;
    }


    if (contents.includes(".00")) {
      let newElementContent = contents.replace(".00", "");
      contents = newElementContent
      element.textContent = contents;
    }

    // if (contents.includes("Final price")) {
    //   let newElementContent = contents.split("price");
    //   const price = newElementContent[1].match(/\$\d+/)?.[0];
    //   const compare = newElementContent[2].match(/\$\d+/)?.[0];
    //   element.innerHTML = `
    //   <em>${price}</em><del>&nbsp&nbsp${compare}</del>
    //   `;
    // }

    element_two.forEach(item =>{
      if (item.textContent.includes(".00")) {
        let twoElement = item.textContent.replace(".00", "");
        item.textContent = twoElement
      }
    })
  }, 500)
});